import { render, staticRenderFns } from "./DepositBlock.vue?vue&type=template&id=02f291ff&scoped=true&"
import script from "./DepositBlock.vue?vue&type=script&lang=js&"
export * from "./DepositBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f291ff",
  null
  
)

export default component.exports